/* eslint-disable @typescript-eslint/restrict-plus-operands */

import {
  BASE_NAME,
  COMMON_PLACEHOLDER,
  DEFAULT_DATETIME_FORMAT,
  IS_PROD
} from '@constants';
import { routerInterFace } from '@router/types';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(isoWeek);

interface optionsListInterface {
  value: string | number;
  label: string | number;
}

export const optionsListFormat = (
  data: any[] = [],
  keyText: string = 'value',
  valText: string = 'label'
): optionsListInterface[] =>
  data?.map((val) => ({
    value: val[keyText],
    label: val[valText]
  }));

export const formatSeconds = (value: number): string => {
  //  秒
  let second = value;
  //  分
  let minute = 0;
  //  小时
  let hour = 0;
  //  天
  //  let day = 0
  //  如果秒数大于60，将秒数转换成整数
  if (second > 60) {
    //  获取分钟，除以60取整数，得到整数分钟
    minute = Math.trunc(second / 60);
    //  获取秒数，秒数取佘，得到整数秒数
    second = Math.trunc(second % 60);
    //  如果分钟大于60，将分钟转换成小时
    if (minute > 60) {
      //  获取小时，获取分钟除以60，得到整数小时
      hour = Math.trunc(minute / 60);
      //  获取小时后取佘的分，获取分钟除以60取佘的分
      minute = Math.trunc(minute % 60);
      //  如果小时大于24，将小时转换成天
      //  if (hour > 23) {
      //    //  获取天数，获取小时除以24，得到整天数
      //    day = parseInt(hour / 24)
      //    //  获取天数后取余的小时，获取小时除以24取余的小时
      //    hour = parseInt(hour % 24)
      //  }
    }
  }

  let result = '' + Math.trunc(second) + 's';
  if (minute > 0) {
    result = '' + Math.trunc(minute) + 'min' + result;
  }
  if (hour > 0) {
    result = '' + Math.trunc(hour) + 'hour' + result;
  }

  return result;
};

export const browser = (): {
  trident: boolean;
  presto: boolean;
  webKit: boolean;
  gecko: boolean;
  mobile: boolean;
  ios: boolean;
  android: boolean;
  iPhone: boolean;
  iPad: boolean;
  webApp: boolean;
  weixin: boolean;
} => {
  // 获取浏览器UA标识
  const u = navigator.userAgent;
  return {
    trident: u.includes('Trident'), // IE内核
    presto: u.includes('Presto'), // opera内核
    webKit: u.includes('AppleWebKit'), // 苹果、谷歌内核
    gecko: u.includes('Gecko') && !u.includes('KHTML'), // 火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
    android: u.includes('Android') || u.includes('Adr'), // android终端
    iPhone: u.includes('iPhone'), // 是否为iPhone或者QQHD浏览器
    iPad: u.includes('iPad'), // 是否iPad
    webApp: !u.includes('Safari'), // 是否web应该程序，没有头部与底部
    weixin: u.includes('MicroMessenger') // 是否微信 （2015-01-22新增）
  };
};

export const exportExcel = (data: any, filename: string) => {
  const blob = new Blob([data]);
  const downloadElement = document.createElement('a');
  const href = window.URL.createObjectURL(blob);
  downloadElement.href = href;
  downloadElement.download = filename;
  document.body.appendChild(downloadElement);
  downloadElement.click();
  document.body.removeChild(downloadElement);
  window.URL.revokeObjectURL(href);
};

export const downloadUrl = (url: string, filename: string) => {
  const downloadElement = document.createElement('a');
  downloadElement.href = url;
  downloadElement.download = filename;
  document.body.appendChild(downloadElement);
  downloadElement.click();
  document.body.removeChild(downloadElement);
};
export const DownloadFile = (res: any) => {
  const fileName =
    res?.headers['content-disposition']?.match(/filename=(.*)/)?.[1];
  const objectUrl = window.URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = fileName;
  a.click();
  a.remove();
};
export const getFlatRouterList = (
  list: routerInterFace[],
  newList?: routerInterFace[]
) => {
  const newArr: any[] = [];
  const arr = list.reduce((routerList, curRouter) => {
    if (curRouter.children && curRouter.children.length >= 0) {
      getFlatRouterList(curRouter.children, routerList);
    } else if (curRouter.component) {
      routerList.push(curRouter);
    }
    return routerList;
  }, newList ?? []);
  arr.forEach((item: any) => {
    return newArr.push({ ...item, path: item.path.replace(/^\/+/, '') });
  });
  return newArr;
};

export const getLoginCodeUrl = (callBackUrl: string): string => {
  return IS_PROD
    ? `https://pros.test.zeiss.com.cn/identity/connect/authorize?response_type=code&client_id=zdp-platform-admin&redirect_uri=${callBackUrl}&scope=openid+profile+email+phone&code_challenge=6CQ6DK8SWnZE9t9_2GWJ6L_-nQ_sTaq9Ht17Z7GQtQQ&code_challenge_method=S256`
    : `https://pros.test.zeiss.com.cn/identity/connect/authorize?response_type=code&client_id=zdp-platform-admin&redirect_uri=${callBackUrl}&scope=openid+profile+email+phone&code_challenge=6CQ6DK8SWnZE9t9_2GWJ6L_-nQ_sTaq9Ht17Z7GQtQQ&code_challenge_method=S256`;
};

export const deepEqual = (obj1: any, obj2: any) => {
  // 如果两个对象都是 null 或者 undefined，返回 true
  if (
    obj1 === null ||
    obj2 === null ||
    obj1 === undefined ||
    obj2 === undefined
  ) {
    return obj1 === obj2;
  }

  // 如果两个对象的类型不同，返回 false
  if (typeof obj1 !== typeof obj2) {
    return false;
  }

  // 如果两个对象都是基本类型，直接比较它们的值
  if (typeof obj1 !== 'object' && typeof obj2 !== 'object') {
    return obj1 === obj2;
  }

  // 如果两个对象的属性个数不同，返回 false
  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
  }

  // 递归比较两个对象的每个属性值
  for (const prop in obj1) {
    if (!deepEqual(obj1[prop], obj2[prop])) {
      return false;
    }
  }

  return true;
};

export const removeEmptyChildren = (nodes: any) => {
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    if (node.children && node.children.length > 0) {
      // 递归处理子节点
      removeEmptyChildren(node.children);
    }
    // 如果children为空数组，则将children字段移除
    if (node.children && node.children.length === 0) {
      delete node.children;
    }
  }
};

export const uuid = () => {
  let d = new Date().getTime();
  if (
    typeof performance !== 'undefined' &&
    typeof performance.now === 'function'
  ) {
    d += performance.now();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};
export const findSubOpenKey = (keys: string, menuList: any[]): string[] => {
  let subOpentKey: string[] = [];

  menuList?.forEach((item: any) => {
    if (item.key === keys) {
      subOpentKey = [item.key];
    } else if (item?.children?.length) {
      const subOpentKeyInChild = findSubOpenKey(keys, item.children);
      if (subOpentKeyInChild.length) {
        subOpentKey = [item.key, ...subOpentKeyInChild];
      }
    }
  });
  return subOpentKey;
};

export const getTextWidth = (text: string, fontSize: number) => {
  // 创建临时元素
  const _span = document.createElement('span');
  // 放入文本
  _span.innerHTML = text;
  // 设置文字大小
  _span.style.fontSize = `${fontSize}px`;
  // 设置字体跟默认一样
  _span.style.fontFamily =
    "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji'";
  // span放入body中
  document.body.appendChild(_span);
  // 获取span的宽度
  const width = _span.offsetWidth;
  // 从body中删除该span
  document.body.removeChild(_span);
  // 返回span宽度
  return width;
};

export const updateCountdown = (diff: number) => {
  const days = Math.floor(diff / (24 * 60 * 60 * 1000));
  const hours = Math.floor((diff % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const minutes = Math.floor((diff % (60 * 60 * 1000)) / (60 * 1000));
  const seconds = Math.floor((diff % (60 * 1000)) / 1000);
  return `${days}天${hours}时${minutes}分${seconds}秒`;
};

//递归处理省市嵌套数据
export const recursiveIterateKeys = (
  array: any,
  valueKey: string = 'areaCode',
  labelKey: string = 'name',
  placeholder: string = '-'
) => {
  let tempArr = array;
  tempArr.forEach((item: any) => {
    item.label = item[labelKey];
    item.value = `${item[valueKey]}${placeholder}${item[labelKey]}`;
    if (item.level == 1) {
      // 0 省  1 市  2 区
      item.children = null;
    }
    if (item.children && item.children.length > 0 && !item.level) {
      recursiveIterateKeys(item.children, valueKey, labelKey, placeholder);
    }
    if (
      item[valueKey] == '999' ||
      (item[valueKey] == '99' && item.dictType === 'projectModel')
    ) {
      item.children = [
        { label: 'A', value: '1$$A', dictType: 'projectClassType' },
        { label: 'B', value: '2$$B', dictType: 'projectClassType' },
        { label: 'C', value: '3$$C', dictType: 'projectClassType' }
      ];
    }
  });
  return tempArr;
};

//查询指定id值所在的项
export const getItemByKey = (array: any = [], key: any, value: any) =>
  array?.find((item: any) => item[key] === value);

export const valToString = (value: any = '', defaultVal: any = '') => {
  return value || value === 0 ? value + '' : defaultVal;
};

export const getCityItem = (
  item: string | string[] = '',
  placeholder = '-'
) => {
  if (!item || !item.length) return null;
  let arr: string[] = [];
  if (typeof item === 'string') {
    arr = item.split(placeholder);
  } else if (Array.isArray(item)) {
    arr = item[0].split(placeholder);
  }
  return {
    code: arr[0],
    label: arr[1]
  };
};

// 格式化金额，添加千位符
export const numFormat = (num: number | string) => {
  if (!num && num !== 0) return '';
  const str = num.toString();
  const res = str.replace(/\d+/, function (n) {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      return $1 + ',';
    });
  });
  return res;
};

export const getDomianRelativeUrl = () => {
  const location = window.location;
  const { hostname } = location;
  if (hostname.indexOf('localhost') > -1) {
    return '';
  } else {
    return BASE_NAME;
  }
};

export const dateFormat = (
  date: any,
  format: string = DEFAULT_DATETIME_FORMAT
) => {
  return date ? dayjs(date).format(format) : null;
};
interface DictItem {
  dictType: string;
  children?: DictItem[];
}
export const filterProductLine = (
  data: DictItem[],
  dictType: string
): DictItem[] => {
  if (!Array.isArray(data) || typeof dictType !== 'string') {
    return [];
  }
  return data.reduce((acc: DictItem[], item: DictItem) => {
    const newItem = { ...item };

    if (item.dictType === dictType) {
      if (item.children?.length) {
        newItem.children = filterProductLine(item.children, dictType);
      }
      acc.push(newItem);
    } else {
      const filteredChildren = item.children?.filter(
        (child) => child.dictType === dictType
      );
      if (filteredChildren?.length) {
        newItem.children = filteredChildren;
        acc.push(newItem);
      }
    }

    return acc;
  }, []);
};
interface DictItem {
  dictKey: string;
  children?: DictItem[];
}
export const findDictKey = (
  data: DictItem[],
  keyPath: string[]
): DictItem[] | undefined => {
  if (!Array.isArray(data) || !keyPath?.length) {
    return undefined;
  }

  const findKeyRecursive = (
    items: DictItem[],
    currentPath: string[],
    depth: number = 0
  ): DictItem | undefined => {
    // 基本情况：到达路径末尾或没有更多子项
    if (!items?.length || depth >= currentPath.length) {
      return undefined;
    }

    // 查找当前层级的匹配项
    const found = items.find((item) => item.dictKey === currentPath[depth]);
    if (!found) {
      return undefined;
    }

    // 如果是最后一个键值，返回找到的项
    if (depth === currentPath.length - 1) {
      return found;
    }

    // 继续在子项中查找
    return findKeyRecursive(found.children ?? [], currentPath, depth + 1);
  };

  const result = findKeyRecursive(data, keyPath);
  return result?.children;
};
export const filterBrandLine = (data: any, dictType: string, value: any) => {
  const dictKeyList = value.map((v: string) => v.split(COMMON_PLACEHOLDER)[0]);
  const item = findDictKey(data, dictKeyList);
  return filterProductLine(item ?? [], dictType);
};
